var freeChapter = {
	pdf: null,
	currentPage: 1,
	zoom: 1
}

var numPages = 0;
var pdfViewerWrap = document.getElementById('pdf_viewer');
var pdfSrc = '';

try {

	if( 'undefined' === typeof pdfViewerWrap || ! pdfViewerWrap ) {
		throw 'error';
	}

	pdfSrc = pdfViewerWrap.dataset.src;

	if( 'undefined' === typeof pdfSrc || ! pdfSrc ) {
		throw 'error';
	}

	pdfjsLib.getDocument(pdfSrc).then((pdf) => {

		freeChapter.pdf = pdf;
		render();
		numPages = pdf.numPages;
		document.getElementById('current_page').setAttribute('max', numPages);

	});
} catch( error ) {
	alert('Wystąpił błąd.');
}

function render() {
	freeChapter.pdf.getPage(freeChapter.currentPage).then((page) => {

		var canvas = document.getElementById("pdf_renderer");
		var ctx = canvas.getContext('2d');

		var viewport = page.getViewport(freeChapter.zoom);

		canvas.width = viewport.width;
		canvas.height = viewport.height;

		page.render({
			canvasContext: ctx,
			viewport: viewport
		});
	});
}

document.getElementById('go_previous').addEventListener('click', (e) => {
	if(freeChapter.pdf == null || freeChapter.currentPage === 1)
		return;

	freeChapter.currentPage -= 1;
	document.getElementById("current_page").value = freeChapter.currentPage;
	render();
});

document.getElementById('go_next').addEventListener('click', (e) => {
	if(freeChapter.pdf == null || freeChapter.currentPage >= freeChapter.pdf._pdfInfo.numPages)
		return;
	freeChapter.currentPage += 1;
	document.getElementById("current_page").value = freeChapter.currentPage;
	render();
});

document.getElementById('current_page').addEventListener('keypress', (e) => {
	if(freeChapter.pdf == null) return;

	// Get key code
	var code = (e.keyCode ? e.keyCode : e.which);

	// If key code matches that of the Enter key
	if(code == 13) {
		var desiredPage =
			document.getElementById('current_page').valueAsNumber;

		if(desiredPage >= 1 && desiredPage <= freeChapter.pdf._pdfInfo.numPages) {
			freeChapter.currentPage = desiredPage;
			document.getElementById("current_page").value = desiredPage;
			render();
		}
	}
});

document.getElementById('zoom_in').addEventListener('click', (e) => {
	if(freeChapter.pdf == null) return;
	freeChapter.zoom += 0.1;
	render();
});

document.getElementById('zoom_out').addEventListener('click', (e) => {
	if(freeChapter.pdf == null) return;
	freeChapter.zoom -= 0.1;
	render();
});
